<template>
  <v-select
    :rules="rules"
    :prepend-icon="icon ? icons.mdiGroup : null"
    :disabled="disabled"
    v-model="datoselect"
    :items="datos"
    label="Moneda"
    item-value="id"
    item-text="nombre"
    :dense="outlined"
    :outlined="outlined"
    :loading="cargando"
    hide-details="auto"
  >
  </v-select>
</template>
  <script>
import { onBeforeMount, ref, watch } from '@vue/composition-api'
import PuestoService from '@/api/servicios/PuestoService'
import { mdiGroup } from '@mdi/js'
import MaestroService from '@/api/servicios/MaestroService'
export default {
  props: {
    value: Object,
    disabled: Boolean,
    dense: Boolean,
    outlined: Boolean,
    todos: Boolean,
    SelectDefault: Number,
    icon: Boolean,
    rules: Object,
  },
  setup(props, contex) {
    const datos = ref([])
    const datoselect = ref(null)
    const cargando = ref(false)
    onBeforeMount(async () => {
      await cargarDatos()
    })

    onBeforeMount(() => {
      if (props.value?.id) {
        datoselect.value = props.value.id
      }
      //dialog.value.save(date.value)
    })

    watch(props, () => {
      if (props.value?.id) {
        datoselect.value = props.value.id
      }
    })

    const cargarDatos = async () => {
      datos.value = []
      if (props.todos == true) {
        datos.value.push({ id: -1, descripcion: 'TODOS' })
      }
      cargando.value = true
      MaestroService.listarMonedas()
        .then(response => {
          if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
            datos.value = datos.value.concat(response.data.datos)
          }
          if (props.value?.id != undefined) {
            
            contex.emit(
              'input',
              datos.value.find(it => datoselect.value == it.id),
            )
          }
          console.log(response.data)
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          cargando.value = false
        })
    }
    watch(datoselect, () => {
     
   
      contex.emit(
        'input',
        datos.value.find(it => datoselect.value == it.id),
      )
    })

    return {
      icons: {
        mdiGroup,
      },
      datos,
      datoselect,
      cargando,
    }
  },
}
</script>